import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Typography } from '@mui/material';
import { useAccessibility } from '../../../../Store/contexts/AccessibilityContext';
import {
  TranscricaoSituacaoVisual,
  TranscricaoStatusConfig,
} from '../transcricaoStatusUtils';

interface Props {
  status: TranscricaoStatusConfig;
}

const visualClassName: Record<TranscricaoSituacaoVisual, string> = {
  pendencia: 'transcricao-situacao-pendencia',
  emAnalise: 'transcricao-situacao-em-analise',
  finalizada: 'transcricao-situacao-finalizada',
  cancelada: 'transcricao-situacao-cancelada',
  entregue: 'transcricao-situacao-entregue',
  processando: 'transcricao-situacao-processando',
  default: 'transcricao-situacao-default',
};

const TranscricaoSituacaoBadge: React.FC<Props> = ({ status }) => {
  const accessibility = useAccessibility();

  return (
    <span className={`transcricao-situacao-badge ${visualClassName[status.visual]}`}>
      <FontAwesomeIcon
        icon={status.icon}
        className="transcricao-situacao-badge-icon"
        aria-hidden="true"
      />
      <Typography
        component="span"
        style={accessibility.textStyleAccessibility}
        className="transcricao-situacao-badge-text"
      >
        {status.label}
      </Typography>
    </span>
  );
};

export default TranscricaoSituacaoBadge;
